import { render, staticRenderFns } from "./phoneOpen.vue?vue&type=template&id=2d9f051c&scoped=true"
import script from "./phoneOpen.vue?vue&type=script&lang=js"
export * from "./phoneOpen.vue?vue&type=script&lang=js"
import style0 from "./phoneOpen.vue?vue&type=style&index=0&id=2d9f051c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f051c",
  null
  
)

export default component.exports